"use strict";

exports.__esModule = true;
var _getDeviceDataItems = require("./getDeviceDataItems");
Object.keys(_getDeviceDataItems).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDeviceDataItems[key]) return;
  exports[key] = _getDeviceDataItems[key];
});
var _getDeviceDataItemStats = require("./getDeviceDataItemStats");
Object.keys(_getDeviceDataItemStats).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDeviceDataItemStats[key]) return;
  exports[key] = _getDeviceDataItemStats[key];
});
var _getDevice = require("./getDevice");
Object.keys(_getDevice).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDevice[key]) return;
  exports[key] = _getDevice[key];
});